import React, { FC } from 'react';
import { Col } from 'reactstrap';
import { FormNodeMarkdownModel } from '../../../../shared/kiosk';
import { RichMarkdownIt } from '../../RichMarkdownIt';

export const FormNodeMarkdown: FC<FormNodeMarkdownModel> = ({ id, markdown }) => {
  return (
    <Col md={12}>
      <div className="form-node form-node-markdown" id={`node-${id}`}>
        <div>
          <RichMarkdownIt source={markdown} />
        </div>
      </div>
    </Col>
  );
};
